import { render } from "./HomeContent4-numbers.vue?vue&type=template&id=118b19c0&scoped=true"
const script = {}

import "./HomeContent4-numbers.vue?vue&type=style&index=0&id=118b19c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118b19c0"]])

export default __exports__